export const statusMFAOptionsMockProps = {
    title: '',
    field: {
        name: 'mfa',
    },
    options: [
        { value: 'email', label: 'Email', id: 1 },
        { value: 'mobile', label: 'Mobile', id: 2 },
    ],
}
